export default __webpack_public_path__ + "static/media/ipX1.1efb8240.svg";